export enum ResourceGroupEnum {
    Applicant = 1,
    Agency,
    Interviewer
}